// Date-filter helpers for the activity log: convert a `YYYY-MM-DD` value from
// an <input type="date"> into the ISO instant of the LOCAL day boundary. The
// API compares full instants against occurred_at (timestamptz), so "from
// today" means the admin's today, not the UTC day.
// (Cf. expiry.ts#fromDateInput, which deliberately uses UTC end-of-day for document validity — different semantics, do not unify.)

const DATE_INPUT = /^(\d{4})-(\d{2})-(\d{2})$/;

function localInstant(
  dateInput: string,
  h: number,
  m: number,
  s: number,
  ms: number,
): string | null {
  const match = DATE_INPUT.exec(dateInput);
  if (!match) return null;
  // Date(y, mIdx, d) interprets the parts in the local timezone.
  const d = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), h, m, s, ms);
  // Round-trip guard: Date() rolls over out-of-range parts ('2026-02-31' →
  // Mar 3). Reject those instead of returning a wrong-day instant.
  if (
    Number.isNaN(d.getTime()) ||
    d.getFullYear() !== Number(match[1]) ||
    d.getMonth() !== Number(match[2]) - 1 ||
    d.getDate() !== Number(match[3])
  ) {
    return null;
  }
  return d.toISOString();
}

/** ISO instant of local 00:00:00.000 on the given date, or null if malformed. */
export function localDayStartIso(dateInput: string): string | null {
  return localInstant(dateInput, 0, 0, 0, 0);
}

/** ISO instant of local 23:59:59.999 on the given date, or null if malformed. */
export function localDayEndIso(dateInput: string): string | null {
  return localInstant(dateInput, 23, 59, 59, 999);
}
